// extracted by css-extract-rspack-plugin
export default {"container":"MegkQ","wrapper":"PplJR","label":"H4W7I","image":"CczLj","image_animated":"g9aq6","imageAnimated":"g9aq6","bounceIn":"U0GW6"};